export enum JobProgressStatus {
  Created = 'CREATED',
  Runnning = 'RUNNING',
  Failed = 'FAILED',
  Error = 'ERROR',
  Success = 'SUCCESS',
  Finished = 'FINISHED',
  Terminated = 'TERMINATED',
  Failure = 'FAILURE',
  Partially_Finished = 'PARTIALLY_FINISHED',
}
